import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import BarCard from '../components/BarCard';
import HomeFilters from '../components/HomeFilters';
import { getBars, toggleUpvote } from '../helpers/api';

export default function HomePage({ userId }) {
  const [filters, setFilters] = useState({
    acceptsVR: false,
    openAfterMidnight: false,
    goodForDate: false,
    hasDrinks: false,
    sort: 'top'
  });

  const [bars, setBars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const loadBars = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      // Build filters object for API
      const apiFilters = {};
      ['acceptsVR', 'openAfterMidnight', 'goodForDate', 'hasDrinks'].forEach((key) => {
        if (filters[key]) apiFilters[key] = true;
      });
      apiFilters.sort = filters.sort;

      const data = await getBars(userId, apiFilters);
      setBars(data.bars || []);
    } catch (err) {
      console.error('Error loading bars:', err);
      setError(err.message || 'Erro ao carregar bares');
    } finally {
      setLoading(false);
    }
  }, [userId, filters]);

  useEffect(() => {
    loadBars();
  }, [loadBars]);

  const handleToggleUpvote = async (bar) => {
    if (!userId) {
      navigate('/login');
      return;
    }

    try {
      const result = await toggleUpvote(userId, bar.id);

      // Update local state
      setBars(prevBars =>
        prevBars.map(b =>
          b.id === bar.id
            ? { ...b, upvoteCount: result.upvoteCount, hasUpvoted: result.hasUpvoted }
            : b
        )
      );
    } catch (err) {
      console.error('Error toggling upvote:', err);
      alert('Erro ao votar: ' + err.message);
    }
  };

  const handleRequireLogin = () => {
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="page-container">
        <p>Carregando bares...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="error-message">
          <p>{error}</p>
          <button onClick={loadBars}>Tentar novamente</button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <HomeFilters filters={filters} onChange={setFilters} />

      <div className="bars-list">
        {bars.length === 0 ? (
          <p className="empty-message">
            {loading ? 'Carregando...' : 'Nenhum bar encontrado com esses filtros.'}
          </p>
        ) : (
          bars.map(bar => (
            <BarCard
              key={bar.id}
              bar={bar}
              userId={userId}
              onToggleUpvote={handleToggleUpvote}
              onRequireLogin={handleRequireLogin}
            />
          ))
        )}
      </div>
    </div>
  );
}
